// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "mapbox-gl" + "." + "f880f21a372ea928e5b9" + ".js";
};